/* eslint-disable @typescript-eslint/no-unused-vars */
import { gql } from '@apollo/client';

/**
 * Счётчики плиток «Обучения». `metaGroups` (группы и журналы) бэкенд отдаёт
 * только `META_GROUPS_ROLES` (Admin, AM, Sales, HR) — методисту, которому
 * «Обучение» открыто, отказ на нём приходил ошибкой. `$withGroups` — из
 * `useGroupPermissions().canReadGroupCounts`; без права плитка остаётся
 * ссылкой, но без числа.
 */
export const SettingsMetaQuery = gql`
  query settingsMeta($withGroups: Boolean!) {
    metaCourses {
      totalCount
    }
    metaGroups @include(if: $withGroups) {
      totalCount
    }
  }
`;
